export enum AppEnvironment {
    DEBUG = "debug",
    ENVIRONMENT = "environment",
    CONFIGURATION_URL = "configurationUrl",
    APP_CONFIGURATION = "appConfiguration",
    MFE_MODULES_MANIFEST = "modulesManifest",
    MFE_MANIFEST_URL = "manifestURL",
    ENDPOINTS = "apiEndpoints",
    URL_REDIRECT_DISABLED = "urlRedirectDisabled",
    FARO_ENABLE = "faroEnable",
    FARO_URL = "faroURL",
    FARO_API_KEY = "faroApiKey",
    GAINSIGHT_KEY = "gainsightKey",
    FEATURE_FLAGS = "featureFlags",
    EXTRA_CONFIG = "extraConfig",
    INIT_HUB_SERVICES = "initHubServices",
    PRIMARY_NAV_HIDDEN = "primaryNavHidden",
    AUTH_ENABLED = "authEnabled",
    AURA_CONFIG = "auraConfig"
}
